import React from "react";
import { useDormantFeatures } from "../utils/useDormantFeatures";
import "./ErrorBoundary.css";

function RecoveryCopy() {
  const features = useDormantFeatures();
  const home = features.dashboard ? "the dashboard" : "Trips";
  return (
    <p>
      Dople is still running, but this view could not load. Your session and data are safe. Try
      again or return to {home}.
    </p>
  );
}

function RecoveryLink() {
  const features = useDormantFeatures();
  if (features.dashboard) {
    return (
      <a href="/dashboard" className="error-boundary-fallback__link">
        Go to dashboard
      </a>
    );
  }
  return (
    <a href="/trips" className="error-boundary-fallback__link">
      Go to Trips
    </a>
  );
}

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      message: error?.message || "Something went wrong rendering this screen.",
    };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info);
  }

  handleRetry = () => {
    this.setState({ hasError: false, message: "" });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary-fallback" role="alert">
          <h2>This screen hit a problem</h2>
          <RecoveryCopy />
          {this.state.message ? (
            <p className="error-boundary-fallback__detail">{this.state.message}</p>
          ) : null}
          <div className="error-boundary-fallback__actions">
            <button type="button" className="home-dashboard__empty-btn" onClick={this.handleRetry}>
              Try again
            </button>
            <RecoveryLink />
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
